import WebAppBanner from './WebAppBanner'
import WebAppBusiness from './WebAppBusiness'
import { lazy, Suspense } from 'react'

const WebAppService = lazy(() => import("./WebAppService"));
const WebAppStory = lazy(() => import("./WebAppStory"));
const WebAppWorld = lazy(() => import("./WebAppWorld"));
const WebAppConversation = lazy(() => import("./WebAppConversation"));
const WebAgileApp = lazy(() => import("./WebAgileApp"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const WebAppImpression = lazy(() => import("./WebAppImpression"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

const faqData = [
  {
    id: "0",
    question: "01. What is Web App Development?",
    answer:
      "Web app development involves creating applications that run on web servers and are accessed through a web browser. These apps are highly interactive and accessible across different devices.",
  },
  {
    id: "1",
    question: "02. How do you ensure the scalability and supportability of a Web App?",
    answer:
      "By using scalable architecture and modern frameworks, we ensure your app can handle increased traffic. Regular updates and support options are also offered to keep it optimized.",
  },
  {
    id: "2",
    question: "03. Can we transition our Web App maintenance from another developer to your team?",
    answer:
      "Yes, our team can take over maintenance, ensure a smooth transition, and make any necessary improvements to enhance the app’s performance.",
  },
  {
    id: "3",
    question: "04. Why choose Custom Web App Development over pre-built solutions?",
    answer:
      "Custom web apps are tailored to meet specific business needs, ensuring better performance, user experience, and scalability compared to generic solutions.",
  },
  {
    id: "4",
    question: "05. What are the key steps involved in developing a Web App?",
    answer:
      "Development typically includes planning, design, development, testing, deployment, and ongoing maintenance to keep the app up-to-date and secure.",
  },
  {
    id: "5",
    question: "06. Do you offer support after the Web App is launched?",
    answer:
      "Yes, we provide ongoing support services to address bugs, updates, and other requirements to keep your app running smoothly.",
  },
  {
    id: "6",
    question:
      "07. How is the driver/agent commission calculated? What is the payout method?",
    answer:
      "The commission for drivers/agents is calculated based on pre-defined rules set within the platform, such as per-trip or hourly rates. Payouts can be automated through bank transfers or other payment gateways.",
  },
];
export default function WebAppDevelopment() {
  return (
    <>
      <WebAppBanner />
      <WebAppBusiness />

      <Suspense fallback={null}>
        <WebAppService />
        <WebAppStory />
        <WebAppWorld />
        <WebAppConversation />
        <WebAppImpression />
        <WebAgileApp />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
